// `Lead.priority` does not enter ranking — see decisions/leads.md 2026-09-19.
//
// No Prisma client import, so both server code and "use client" components can
// import this.

import type { LeadPriority } from "@/generated/prisma/enums";

// Key order is the render order. Labels name a dimension, never a requirement:
// the erhverv preferences step already has a "Dansktalende personale" checkbox.
const PRIORITY_LABELS: Record<LeadPriority, string> = {
  PRIS: "Prisen",
  HURTIG_START: "Hurtig start",
  KVALITET: "Kvalitet og certificeringer",
  DANSKTALENDE: "Kommunikation på dansk",
};

export const PRIORITY_OPTIONS = (Object.keys(PRIORITY_LABELS) as LeadPriority[]).map((value) => ({
  value,
  label: PRIORITY_LABELS[value],
}));

export function isLeadPriority(value: unknown): value is LeadPriority {
  return typeof value === "string" && value in PRIORITY_LABELS;
}

export function humanizePriority(priority: LeadPriority): string {
  return PRIORITY_LABELS[priority];
}
